// BoardLayout.js
import React from 'react';
import Sidebar from '../Sidebar';
import BoardHeader from './BoardHeader';

const BoardLayout = ({
  sidebarCollapsed,
  setSidebarCollapsed,
  searchTerm,
  setSearchTerm,
  filterAssignee,
  setFilterAssignee,
  filterPriority,
  setFilterPriority,
  boardStats,
  filteredTasks,
  tasks,
  handleClearSearch,
  handleAddTask,
  handleExportData,
  users,
  showControls = true,
  children
}) => {
  return (
    <div style={{
      display: 'flex',
      height: '100%',
      background: '#f5f5f5',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <Sidebar
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filterAssignee={filterAssignee}
        setFilterAssignee={setFilterAssignee}
        filterPriority={filterPriority}
        setFilterPriority={setFilterPriority}
        boardStats={boardStats}
        filteredTasks={filteredTasks}
        tasks={tasks}
        handleClearSearch={handleClearSearch}
        handleAddTask={handleAddTask}
        handleExportData={handleExportData}
        users={users}
        showControls={showControls}
      />

      <div style={{
        flex: 1,
        padding: '16px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        minHeight: 0,
        overflowX: 'hidden'
      }}>
        <BoardHeader
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          filteredCount={filteredTasks?.length || 0}
          totalCount={tasks?.length || 0}
        />

        {children}
      </div>
    </div>
  );
};

export default BoardLayout;


